var React = require('react');

import { GenericSimpleToggleButton, GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';

const PopUpRecuperacion = (props) => {
    return (
        <div className="dropdown state" id="state-delete">
            <button type="button" data-toggle="dropdown" data-target="#state-delete"
                className="btn btn-cta btn-sm btn-deleted">ELIMINADO</button>
            <ul className="dropdown-menu">
                <li className="bottom-separator-xs">
                    <p>{"Eliminado por " + props.usuario.EliminadoPor + " el " + props.usuario.FechaEliminado + " a las " + props.usuario.HoraEliminado}</p>
                </li>
                {props.functions.Modificacion &&
                    <li className="state-bottom">
                        <div className="row">
                            <div className="col-xs-12 text-right">
                                <button className="btn btn-secondary"
                                type="button" onClick={() => props.setUserState(props.usuario.Id, true, false)} >Recuperar</button>
                            </div>
                        </div>
                    </li>
                }
            </ul>
        </div>
    );
}

export default PopUpRecuperacion;